

import SignalRContext, { ISignalROnMessage } from "@/contexts/api/SignalRContext";
import { useContext, useEffect } from "react";

export const useSignalROnMessage = <TData = any>(channel?: string, listener?: ISignalROnMessage<TData>) => {
    const context = useContext(SignalRContext);

    useEffect(() => {
        if (channel && listener) 
        {
            const unsubscribe = context.addOnMessageListener(channel, listener);
    
            return () => {
                unsubscribe();
            }
        }
    }, [context, channel, listener]);
}

export default useSignalROnMessage;